import { render, staticRenderFns } from "./efatura.vue?vue&type=template&id=1ba111ff"
import script from "./efatura.vue?vue&type=script&lang=js"
export * from "./efatura.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports